import { useMemo } from 'react';
import { getValidatedOrigin, isPermittedOrigin } from '../../lib/origin/originUtils';

/**
 * React hook that checks if the current origin is in the list of permitted origins
 * The result is memoized since window.location.origin shouldn't change during component lifecycle
 * @returns true if the current origin is permitted, false otherwise
 */
export function useIsPermittedOrigin(): boolean {
  return useMemo(() => isPermittedOrigin(), []);
}

/**
 * React hook that returns the validated current origin
 * The result is memoized since window.location.origin shouldn't change during component lifecycle
 * @returns The current origin if it's permitted
 * @throws Error if the current origin is not permitted
 */
export function useValidatedOrigin(): string {
  return useMemo(() => getValidatedOrigin(), []);
}
